<template>
  <div class="map-container">
    <div class="map-content">
      <l-map style="height: 100%;" :zoom="zoom" :center="center" :options="mapOptions" @update:center="centerUpdated" @update:zoom="zoomUpdated" @ready="onMapReady">
        <l-tile-layer 
          v-for="layer in layers"
          :key="layer.name"
          :url="layer.url"
          :attribution="layer.attribution"
          :subdomains="layer.subdomains"
          :layer-type="layer.layerType"
          :visible="layer.visible"
          :options="layer.options"
        />
        <l-marker :lat-lng="markerLatLng">
          <l-popup>
            <div>
              <h3>{{ markerInfo.title }}</h3>
              <p>{{ markerInfo.description }}</p>
              <el-button type="primary" size="small" @click="showMarkerDetails">
                查看详情
              </el-button>
            </div>
          </l-popup>
        </l-marker>
        
        <!-- 直接在地图内添加比例尺控件 -->
        <l-control-scale position="bottomleft" :imperial="false" :metric="true"></l-control-scale>
      </l-map>

      <div class="map-type-buttons">
        <el-tooltip content="矢量地图" placement="left">
          <div class="map-type-icon" 
               :class="{ active: currentMapType === 'normal' }" 
               @click="changeMapType('normal')">
            <i class="el-icon-map-location"></i>
          </div>
        </el-tooltip>
        <el-tooltip content="卫星影像" placement="left">
          <div class="map-type-icon" 
               :class="{ active: currentMapType === 'satellite' }" 
               @click="changeMapType('satellite')">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-tooltip>
        <el-tooltip content="地形图" placement="left">
          <div class="map-type-icon" 
               :class="{ active: currentMapType === 'terrain' }" 
               @click="changeMapType('terrain')">
            <i class="el-icon-data-analysis"></i>
          </div>
        </el-tooltip>
      </div>
      
      <div class="map-controls-wrapper">
        <!-- 仅显示经纬度部分 -->
        <div class="coordinate-panel">
          <div class="coordinate-line">经度 {{ formatLongitude }}</div>
          <div class="coordinate-line">纬度 {{ formatLatitude }}</div>
        </div>
      </div>
    </div>
    
    <el-dialog
      title="位置详情"
      :visible.sync="dialogVisible"
      width="30%">
      <div class="location-details">
        <el-descriptions :column="1" border>
          <el-descriptions-item label="名称">{{ markerInfo.title }}</el-descriptions-item>
          <el-descriptions-item label="经度">{{ markerLatLng[1] }}</el-descriptions-item>
          <el-descriptions-item label="纬度">{{ markerLatLng[0] }}</el-descriptions-item>
          <el-descriptions-item label="描述">{{ markerInfo.description }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="dialogVisible = false">确定</el-button>
      </span>
    </el-dialog>
    
    <el-drawer
      title="地图工具"
      :visible.sync="drawerVisible"
      direction="rtl"
      size="25%">
      <div class="map-tools">
        <el-divider content-position="left">地图控制</el-divider>
        <div class="tool-item">
          <span>缩放级别: {{ zoom }}</span>
          <el-slider v-model="zoom" :min="5" :max="18" :step="1"></el-slider>
        </div>
        
        <el-divider content-position="left">位置搜索</el-divider>
        <div class="tool-item">
          <el-input
            placeholder="输入地点名称"
            v-model="searchKeyword"
            class="search-input">
            <el-button slot="append" icon="el-icon-search" @click="searchLocation"></el-button>
          </el-input>
        </div>
        
        <el-divider content-position="left">图层控制</el-divider>
        <div class="tool-item">
          <el-checkbox v-model="showLabels">显示标注</el-checkbox>
        </div>
      </div>
    </el-drawer>
    
    <div class="map-footer">
      <el-button type="primary" icon="el-icon-menu" circle @click="drawerVisible = true"></el-button>
    </div>
  </div>
</template>

<script>
import TianDiTuMapScript from './TianDiTuMap.js'
export default TianDiTuMapScript
</script>

<style scoped>
@import './TianDiTuMap.css';

.map-controls-wrapper {
  position: absolute;
  bottom: 25px;
  left: 15px;
  z-index: 1000;
}

.coordinate-panel {
  background-color: #fff;
  border-radius: 4px;
  padding: 6px 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  min-width: 120px;
  margin-bottom: 5px;
  border: 1px solid #e0e0e0;
}

.coordinate-line {
  color: #222;
  font-size: 12px;
  font-family: 'Consolas', monospace;
  text-align: left;
  margin: 2px 0;
  white-space: nowrap;
}
</style>

<style>
/* 覆盖Leaflet比例尺样式，使其与我们的主题一致 */
.leaflet-control-scale-line {
  border-color: #e0e0e0 !important;
  background-color: #fff !important;
  color: #222 !important;
  margin-left: 10px !important;
  margin-bottom: 5px !important;
  box-shadow: 0 2px 4px rgba(0,0,0,0.08);
}
</style> 